import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAROSU4i_sWT6IAygKkdWHMU1mOSV2_IyE",
  authDomain: "ai-kymbms.firebaseapp.com",
  projectId: "ai-kymbms",
  storageBucket: "ai-kymbms.firebasestorage.app",
  messagingSenderId: "988815595589",
  appId: "1:988815595589:web:a18fb537efda76f7d46b2c",
  measurementId: "G-7H7TT01CVM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let analytics = null;
if (typeof window !== 'undefined') {
  isSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized successfully!');
    }
  }).catch(err => console.warn('Firebase Analytics not supported in this environment:', err));
}

export { app, analytics };
